import uniqueId from 'lodash/uniqueId';

import {
  IntegrationV1,
  testHasIntegration,
} from '~/components/Admin/IntegrationPage/IntegrationPageUtils';
import { User } from '~/types/User';

import { ESignatureIntegration } from '../../types';

type IntegrationInput = ESignatureIntegration | IntegrationV1;

export const mappedEnrichedIntegrations = (
  integrations: IntegrationInput[],
  currentUser: User,
  isV2Enable: boolean,
) => {
  return integrations.map((integration) => {
    const { type, id } = integration as { type?: string; id?: string };

    const key = (type ?? id ?? uniqueId('integration_')) as string;

    return {
      ...integration,
      disabled: isV2Enable
        ? false
        : !testHasIntegration(
            currentUser,
            integration as IntegrationV1,
            isV2Enable,
          ),
      _key: key,
    };
  });
};
